module.exports = __webpack_public_path__ + "static/media/favicon.c7b7adec.ico";